module.exports = __webpack_public_path__ + "img/profil_lapper_Utne-pettersen.1123ffeb.png";